/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Range, getTrackBackground } from 'react-range';
import { HSRSkillsJSON } from './hsr-skill-data';

interface IProps {
  id?: string;
  maxLevel?: number;
  element?: string;
  gen?: string;
  break_primary?: string;
  break_secondary?: string;
  ult_cost?: number;
  isEnhanced?: boolean;
  disabled?: boolean;
}

export const HSRSkill: React.FC<IProps> = ({
  id,
  maxLevel,
  element,
  gen,
  break_primary,
  break_secondary,
  ult_cost,
  isEnhanced,
  disabled
}) => {
  const [originalskillDesc, setOriginalskillDesc] = useState(
    HSRSkillsJSON[id].desc
  );
  const [simpleDesc, setSimpleDesc] = useState(HSRSkillsJSON[id].simple_desc);
  const [originalParams, setOriginalParams] = useState(
    HSRSkillsJSON[id].params
  );
  const [skillDesc, setSkillDesc] = useState(originalskillDesc);
  const [currentLevel, setCurrentLevel] = useState([1]);
  const [color, setColor] = useState('#979797');

  useEffect(() => {
    if (maxLevel === 7) {
      setCurrentLevel([6]);
    } else if (maxLevel === 12) {
      setCurrentLevel([10]);
    } else if (maxLevel === 8) {
      setCurrentLevel([8]);
    }
  }, []);

  useEffect(() => {
    if (element === 'Wind') {
      setColor('#61CF93');
    } else if (element === 'Lightning') {
      setColor('#C65ADE');
    } else if (element === 'Fire') {
      setColor('#EE473D');
    } else if (element === 'Ice') {
      setColor('#2692D3');
    } else if (element === 'Quantum') {
      setColor('#6057C9');
    } else if (element === 'Imaginary') {
      setColor('#e6d863');
    } else if (element === 'Physical') {
      setColor('#979797');
    }
  }, []);

  useEffect(() => {
    let param1 = Math.round(originalParams[currentLevel[0] - 1][0]);
    let param2 = Math.round(originalParams[currentLevel[0] - 1][1]);
    let param3 = Math.round(originalParams[currentLevel[0] - 1][2]);
    let param4 = Math.round(originalParams[currentLevel[0] - 1][3]);
    let param5 = Math.round(originalParams[currentLevel[0] - 1][4]);
    let param6 = Math.round(originalParams[currentLevel[0] - 1][5]);
    let param7 = Math.round(originalParams[currentLevel[0] - 1][6]);
    let param8 = Math.round(originalParams[currentLevel[0] - 1][7]);
    let currentstring1 = '#1[i]';
    let currentstring2 = '#2[i]';
    let currentstring3 = '#3[i]';
    let currentstring4 = '#4[i]';
    let currentstring5 = '#5[i]';
    let currentstring6 = '#6[i]';
    let currentstring7 = '#7[i]';
    let currentstring8 = '#8[i]';

    if (originalskillDesc.includes('#1[i]%')) {
      param1 = Math.round(originalParams[currentLevel[0] - 1][0] * 1000) / 10;
      currentstring1 = '#1[i]%';
    }

    if (originalskillDesc.includes('#2[i]%')) {
      param2 = Math.round(originalParams[currentLevel[0] - 1][1] * 1000) / 10;
      currentstring2 = '#2[i]%';
    }

    if (originalskillDesc.includes('#3[i]%')) {
      param3 = Math.round(originalParams[currentLevel[0] - 1][2] * 1000) / 10;
      currentstring3 = '#3[i]%';
    }

    if (originalskillDesc.includes('#4[i]%')) {
      param4 = Math.round(originalParams[currentLevel[0] - 1][3] * 1000) / 10;
      currentstring4 = '#4[i]%';
    }

    if (originalskillDesc.includes('#5[i]%')) {
      param5 = Math.round((originalParams[currentLevel[0] - 1][4] * 1000) / 10);
      currentstring5 = '#5[i]%';
    }

    if (originalskillDesc.includes('#6[i]%')) {
      param6 = Math.round((originalParams[currentLevel[0] - 1][5] * 1000) / 10);
      currentstring6 = '#6[i]%';
    }

    if (originalskillDesc.includes('#7[i]%')) {
      param7 = Math.round((originalParams[currentLevel[0] - 1][6] * 1000) / 10);
      currentstring7 = '#7[i]%';
    }

    if (originalskillDesc.includes('#8[i]%')) {
      param8 = Math.round((originalParams[currentLevel[0] - 1][7] * 1000) / 10);
      currentstring8 = '#8[i]%';
    }

    const newString = originalskillDesc
      .replaceAll(
        `${currentstring1}`,
        `<b>${param1}${currentstring1 === '#1[i]%' ? '%' : ''}</b>`
      )
      .replaceAll(
        `${currentstring2}`,
        `<b>${param2}${currentstring2 === '#2[i]%' ? '%' : ''}</b>`
      )
      .replaceAll(
        `${currentstring3}`,
        `<b>${param3}${currentstring3 === '#3[i]%' ? '%' : ''}</b>`
      )
      .replaceAll(
        `${currentstring4}`,
        `<b>${param4}${currentstring4 === '#4[i]%' ? '%' : ''}</b>`
      )
      .replaceAll(
        `${currentstring5}`,
        `<b>${param5}${currentstring5 === '#5[i]%' ? '%' : ''}</b>`
      )
      .replaceAll(
        `${currentstring6}`,
        `<b>${param6}${currentstring6 === '#6[i]%' ? '%' : ''}</b>`
      )
      .replaceAll(
        `${currentstring7}`,
        `<b>${param7}${currentstring7 === '#7[i]%' ? '%' : ''}</b>`
      )
      .replaceAll(
        `${currentstring8}`,
        `<b>${param8}${currentstring8 === '#8[i]%' ? '%' : ''}</b>`
      )
      .replaceAll(`Wind DMG`, `<u>Wind DMG</u>`)
      .replaceAll(`Imaginary DMG`, `<u>Imaginary DMG</u>`)
      .replaceAll(`Lightning DMG`, `<u>Lightning DMG</u>`)
      .replaceAll(`Imaginary DMG`, `<u>Imaginary DMG</u>`)
      .replaceAll(`Ice DMG`, `<u>Ice DMG</u>`)
      .replaceAll(`Quantum DMG`, `<u>Quantum DMG</u>`)
      .replaceAll(`Fire DMG`, `<u>Fire DMG</u>`)
      .replaceAll(`\n`, `<br />`);
    setSkillDesc(newString);
  }, [currentLevel]);
  return (
    <>
      <div className="skill-header">
        <div className={`skill-icon ${element}`}>
          {HSRSkillsJSON[id].type_text}
          {isEnhanced ? <span>(Enhanced)</span> : ''}
        </div>
        <div className="skill-info">
          <p className="skill-name">{HSRSkillsJSON[id].name}</p>
          <p className="skill-type">
            {HSRSkillsJSON[id].effect_text ? (
              <>
                {' '}
                <span className="type">{HSRSkillsJSON[id].effect_text}</span>
              </>
            ) : (
              ''
            )}{' '}
            {ult_cost && (
              <>
                | <span>{ult_cost} energy cost </span>
              </>
            )}
          </p>
        </div>
      </div>
      {maxLevel === 1 ? (
        <></>
      ) : (
        <div className="level-changer">
          <span className="current-level">
            Lv.{' '}
            <span className="level" style={{ color: color }}>
              {currentLevel}
            </span>
          </span>
          <div className={`level-slider ${disabled ? 'disabled' : 'enabled'}`}>
            <Range
              disabled={disabled}
              step={1}
              min={1}
              max={maxLevel}
              values={currentLevel}
              onChange={(values) => setCurrentLevel(values)}
              renderTrack={({ props, children }) => (
                <div
                  role="button"
                  tabIndex={0}
                  onMouseDown={props.onMouseDown}
                  onTouchStart={props.onTouchStart}
                  style={{
                    ...props.style,
                    height: '36px',
                    display: 'flex',
                    width: '100%'
                  }}
                >
                  <div
                    ref={props.ref}
                    style={{
                      height: '5px',
                      width: '100%',
                      borderRadius: '0px',
                      background: getTrackBackground({
                        values: currentLevel,
                        colors: [color, '#484950'],
                        min: 1,
                        max: maxLevel
                      }),
                      alignSelf: 'center'
                    }}
                  >
                    {children}
                  </div>
                </div>
              )}
              renderThumb={({ props, isDragged }) => (
                <div
                  {...props}
                  style={{
                    ...props.style,
                    height: '20px',
                    width: '20px',
                    borderRadius: '0px',
                    backgroundColor: '#FFF',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <div
                    style={{
                      height: '14px',
                      width: '5px',
                      backgroundColor: isDragged ? color : '#484950'
                    }}
                  />
                </div>
              )}
            />
          </div>
        </div>
      )}
      <div className={`additional-information`}>
        <p>
          Energy gain: <span>{gen ? gen : '0'}</span>
        </p>
        <p>
          Break:{' '}
          {/* <span>
            {break_primary ? break_primary : '-'}{' '}
            {break_secondary ? <>+ {break_secondary} adjacent</> : ''}
          </span> */}
          <span>
            {break_primary ? (Number(break_primary) / 3).toFixed(0) : '-'}{' '}
            {break_secondary ? (
              <>+ {(Number(break_secondary) / 3).toFixed(0)} adjacent</>
            ) : (
              ''
            )}
          </span>
        </p>
      </div>
      <div
        className={`skill-with-coloring ${element}`}
        dangerouslySetInnerHTML={{
          __html: skillDesc
        }}
      />
      {/* {disabled ? (
        <>
          <div
            className={`skill-with-coloring ${element}`}
            dangerouslySetInnerHTML={{
              __html: simpleDesc
            }}
          />
        </>
      ) : (
        <>
          <div
            className={`skill-with-coloring ${element}`}
            dangerouslySetInnerHTML={{
              __html: skillDesc
            }}
          />
        </>
      )} */}
    </>
  );
};
